// The site's own origin, in a module that imports nothing.
//
// Split out of conversionRoutes.js so both it and blogRoutes.js can read the
// origin without importing each other: conversionRoutes needs getBlogPaths()
// for the indexable set, blogRoutes needs the origin for canonicals, and a
// cycle between them resolves to `undefined` at module-init time depending on
// which module the bundler happens to evaluate first.
//
// A domain change is still one edit.
export const SITE_ORIGIN = 'https://subscene.io';
